import React from 'react';

import clsx from 'clsx';
import { getColorType } from 'PDF/helpers/documentStyle';
import { IStageItem } from 'PDF/pages/MarketingAndSales/types';

import { SalesTimeline } from './SalesTimeline';
import { Bookmark } from '../Timeline/Bookmark';

interface ISalesFunnelProps {
  data: IStageItem[];
}

export const SalesFunnel: React.FC<ISalesFunnelProps> = ({ data }) => (
  <div className={clsx('container', 'timeline-wrapper', 'sales', getColorType())}>
    <SalesTimeline className="my-vertical-progress">
      {data.map((item, index) => (
        <Bookmark
          key={index}
          className={
            index === data.length - 1
              ? (index + 1) % 2 == 1
                ? 'last-timeline-item-odd'
                : 'last-timeline-item-even'
              : ''
          }
        >
          <h1 className="date">{item.stage}</h1>
          <p className="description">{item.description}</p>
        </Bookmark>
      ))}
    </SalesTimeline>
  </div>
);
